import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class Workshops extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background workshop-page">
                    <Banner heading="Workshops" />
                    <BackButton href={hyperlinks["home"]} text="❮ Home" />
                    <Row className="workshop-content">
                        <Col md={8} mdOffset={2}>
                            <div>
                                <p>
                                    Our members-only workshops aim to provide the space for members to meet in-person to establish new, and strengthen existing, connections that can lead to future partnerships.
                                    The first LUOW members-only workshop took place in Los Angeles in 2019. Los Angeles Department of Water and Power was the host utility. In 2022, in-person workshops resumed, with workshops taking place alongside three major conferences: Singapore International Water Week, the Global Water Summit in Madrid, and the American Water Summit in Los Angeles.
                                </p>

                                <h2>Madrid 2022</h2>

                                <div>
                                    <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:6934889894737547264" height="1168" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
                                </div>

                                <h2>Singapore 2022</h2>

                                <div>
                                    <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:6925019857847488512" allowfullscreen="" title="Embedded post" width="504" height="866" frameborder="0"></iframe>
                                </div>

                                <h2>Los Angeles 2019</h2>

                                <div>
                                    <iframe src="https://player.vimeo.com/video/372687731?h=cbb6d47d80" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                                </div>

                            </div>

                            <Button className="become-a-member" href={hyperlinks["newMember"]}>Become a member</Button>
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/Workshops.jsx.erb